// extracted by mini-css-extract-plugin
export default {"alreadyBtn":"InputText_alreadyBtn__r5xE7","inputContainer":"InputText_inputContainer__MWvUc","container":"InputText_container__+tbXi","title":"InputText_title__75ojF"};